import * as React from 'react';

import { SaveSearchProvider as Provider } from '@/packages/SaveSearchModal';

import { getSaveSearchMicrofrontend } from '@/microfrontends/filters/shared/services/getSaveSearchMicrofrontend';
import { useListingSelector } from '@/microfrontends/filters/shared/store/slices/listing/selectors';
import { useUserSelector } from '@/microfrontends/filters/shared/store/slices/user/selectors';
import { useApplicationContext } from '@/microfrontends/filters/shared/utils/applicationContext';

enum ESource {
  Card = 'card',
  Listing = 'listing',
  Map = 'map',
}

export const SaveSearchModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getSaveSearchMicrofrontend(context), [context]);

  const listing = useListingSelector();
  const user = useUserSelector();
  const jsonQuery = listing.jsonQuery;
  const queryString = listing.meta.queryString;
  const title = listing.meta.h1;
  const email = user.data.isAuthenticated ? user.data.email : null;
  const isAuthenticated = user.data.isAuthenticated;

  const params = {
    jsonQuery,
    email,
    title,
    isAuthenticated,
    source: ESource.Listing,
    analyticsParams: {
      pageType: 'Listing',
      listingType: 'list',
      queryString,
      isFromBanner: false,
    },
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
